
import { Options, Vue } from 'vue-property-decorator'

@Options({
  name: 'Exclamation'
})
export default class Exclamation extends Vue {}
